export default "__VITE_ASSET__BdPBvK9T__"